module.exports = __webpack_public_path__ + "static/media/1023446.b0c28425.png";